export default __webpack_public_path__ + "static/media/award.a50c1fdc.svg";